<template>
  <a-config-provider
    :locale="antdLocale"
    :theme="theme"
    :component-size="componentSize"
    :direction="direction"
  >
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import { useAntdConfig } from '@/config/antd'

// 使用全局配置
const { antdLocale, theme, componentSize, direction } = useAntdConfig()
</script>

<style>
/* Global styles */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#app {
  min-height: 100vh;
}

/* App-level responsive utilities are now handled in Layout.vue */

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>